// we are getting version from the server to have a versioned entity
// version is a hash (etag) and it must be the same when we send it back
export type Versioned<T> = {
  data: T;
  version: string;
};

export const versioned = <T>(data: T, version: string) => ({
  data,
  version,
});
